<template>
  <div class="w-full flex items-center justify-center">
    <div class="mt-2 mb-1 w-full relative">
      <label v-if="label != undefined" :for="`${id}`" class="text-left block mb-1 text-sm font-semibold text-gray-800 ">
        {{ label }} {{ mode }}
      </label>
      <div class="relative w-full flex justify-start items-center">
        <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
          <!-- icône -->
        </div>
        <input
          :id="`date-${id}`"
          ref="dp"
          type="text"
          :disabled="mode === 'display'"
          class="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2    "
          :placeholder="placeholder || 'Sélectionner date'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "flowbite-datepicker/Datepicker";
import fr from "flowbite-datepicker/locales/fr";

export default {
  name: "ContentDate",
  props: {
    id: String,
    label: String,
    placeholder: String,
    required: Boolean,
    mode: String,
    value: String,          // attendu au format "YYYY-MM-DD"
    config: Object,
  },
  data() {
    return { dp: null };
  },
  watch: {
    value(val) {
     
      // Mettez à jour l’UI si la prop change
      if (this.dp) this.dp.setDate(this.toDisplay(val || this.todayIso()));
    },
  },
  mounted() {
    Object.assign(Datepicker.locales, fr);

    this.dp = new Datepicker(this.$refs.dp, {
      format: "dd/mm/yyyy",
      autohide: true,
      language: "fr",
      rangePicker: false,
      title: "Choisir une date ..",
    });

    // init valeur
    const initialIso = this.value || this.todayIso();
    this.dp.setDate(this.toDisplay(initialIso));

    // écoute l’événement émis par Flowbite
    this.$refs.dp.addEventListener("changeDate", () => {



      const disp = this.$refs.dp.value;       // "dd/mm/yyyy"
      const iso = this.toIso(disp);           // "yyyy-mm-dd"
      
    
      
      
      this.$emit("value-changed", iso);
      this.$emit("update:value", iso);        // support v-model si besoin
    });
  },
  methods: {
    todayIso() {
      const d = new Date();
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    },
    toDisplay(iso) {
      // "yyyy-mm-dd" -> "dd/mm/yyyy"
      if (!iso) return "";
      const [y, m, d] = iso.split("-");
      return `${d}/${m}/${y}`;
    },
    toIso(disp) {
      // "dd/mm/yyyy" -> "yyyy-mm-dd"
      if (!disp) return "";
      const [d, m, y] = disp.split("/");
      return `${y}-${m}-${d}`;
    },
  },
};
</script>
